<template>
	<div class="seting">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span>个人设置</span>
			<div></div>
		</div>
		<!-- 内容 -->
		<div class="top">
			<van-cell title="头像" is-link class="icon">
				<template slot="default">
					<van-uploader class="uploader" :after-read="subCamera">
						<img v-if="userInfo.image == null" src="../../../assets/user.png" alt="">
						<img v-else :src="userInfo.image | handleUrl" alt="">
					</van-uploader>
				</template>
			</van-cell>
			<van-cell title="昵称" :value="userInfo.username" is-link
				:to="{ path: 'name', query: { name: userInfo.username,id: userInfo.id }}" />
			<van-cell :value="userInfo.tel">
				<template slot="title">
					<span class="custom-title">电话号码</span>
					<van-tag color="#f1452f">已验证</van-tag>
				</template>
			</van-cell>
			<van-cell title="商户会员编号" :value="userInfo.user_num" />
		</div>
		<div class="center">
			<van-cell title="分享APP给我的好友" is-link  />
			<van-cell title="账户管理" is-link to="/account" />
		</div>
		<div class="bottom">
			<van-cell title="收货地址" is-link to="/site" />
			<van-cell title="发票管理" is-link to="/overinvoices" />
		</div>
		<div class="btn">
			<button @click="logout">退出当前账号</button>
		</div>
	</div>

</template>

<script>
	export default {
		inject: ['reload'],
		data() {
			return {
				userInfo: {}
			}
		},
		created() {
			this.$axios.post(baseUrl + '/mobile/User/userInformation', {
				token: localStorage.getItem('Authorization')
			}).then((res) => {
				if (res.data.code == 2) {
					this.userInfo = res.data.data
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		methods: {
			//退出登录
			logout() {
				this.$axios.post(baseUrl + '/mobile/User/logout', {
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					if (res.data.code == 1) {
						localStorage.removeItem('Authorization');
						this.$toast(res.data.msg);
						setTimeout(() => {
							this.$router.push({
								path: '/Home'
							})
						}, 1000)
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			//拍照上传
			subCamera(file) {
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				this.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then((res) => {
					if (res.data.code == 11) {
						this.$axios.post(baseUrl + '/mobile/User/userUpdateImage', {
							image: res.data.data,
							token: localStorage.getItem('Authorization')
						}).then((res) => {
							if (res.data.code == 7) {
								this.reload();
							}
						}).catch((err) => {
							console.log(err);
						})
					}
				}).catch((err) => {
					console.log(err);
				})
			}
		}
	}
</script>

<style scoped>
	@import "seting.css"
</style>


// WEBPACK FOOTER //
// src/components/min/setting/seting.vue